import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import React from 'react';
import Dashboard from './pages/dashboard';
import UserLogin from './pages/userLogin';
import NotFound from './pages/notFound';
import ProtectedRoute from './config/protectedRoute';
import Teams from './pages/teams';
import AddTeam from './pages/addTeam';
import TeamDetails from './pages/teamDetails';
import EditTeam from './pages/editTeam';
import Tickets from './pages/tickets';
import TicketDetails from './pages/ticketDetails';
import Analytics from './pages/analytics';
import Chats from "./pages/chats";
import TicketManage from "./pages/ticketManage";
import CreateBot from "./pages/createBot";
import ChatbotFlow from "./pages/chatbotFlow";
import Trial from "./pages/trial";
import WhatsappApi from "./pages/whatsappApi";
import WhatsappAccounts from "./pages/whatsappAccounts";
import Account from "./pages/account.js";
import Customers from "./pages/customers.js";
import Clients from "./pages/clients.js";
import Users from "./pages/users.js";
import NewClient from "./pages/newClient.js";
import ClientDetails from "./pages/clientDetails.js";
import CustomerDetails from "./pages/customerDetails.js";
import Billing from "./pages/billing.js";


function App() {
  return (
    <React.Fragment>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
      />
        <BrowserRouter>
          <div className="App">
            <Routes>
              <Route path="/" element={<UserLogin />} />
              <Route path="/teams" element={<ProtectedRoute element={<Teams />} />} />
              <Route path="/account" element={<ProtectedRoute element={<Account />} />} />
              <Route path="/clients" element={<ProtectedRoute element={<Clients />} />} />
              <Route path="/billing" element={<ProtectedRoute element={<Billing />} />} />
              <Route
                path="/client/:clientId"
                element={<ProtectedRoute element={<ClientDetails />} />}
              />
              <Route path="/newClient" element={<ProtectedRoute element={<NewClient />} />} />
              <Route path="/customers" element={<ProtectedRoute element={<Customers />} />} />
              <Route
                path="/customer/:customerId"
                element={<ProtectedRoute element={<CustomerDetails />} />}
              />
              <Route path="/users" element={<ProtectedRoute element={<Users />} />} />
              <Route
                path="/teams/add"
                element={<ProtectedRoute element={<AddTeam />} />}
              />
              <Route
                path="/teams/:userObjId"
                element={<ProtectedRoute element={<TeamDetails />} />}
              />
              <Route
                path="/teams/:userObjId/edit"
                element={<ProtectedRoute element={<EditTeam />} />}
              />
              <Route
                path="/tickets"
                element={<ProtectedRoute element={<Tickets />} />}
              />
              <Route
                path="/chats"
                element={<ProtectedRoute element={<Chats />} />}
              />
              <Route
                path="/tickets/ticketdetails/:ticketId"
                element={<ProtectedRoute element={<TicketDetails />} />}
              />
              <Route
                path="/tickets/ticketmanage/:ticketId"
                element={<ProtectedRoute element={<TicketManage />} />}
              />
              <Route
                path="/create-bot"
                element={<ProtectedRoute element={<CreateBot />} />}
              />
              <Route
                path="/bot-flow"
                element={<ProtectedRoute element={<ChatbotFlow />} />}
              />
              <Route
                path="/whatsapp-api"
                element={<ProtectedRoute element={<WhatsappApi />} />}
              />
              <Route
                path="/whatsapp-accounts"
                element={<ProtectedRoute element={<WhatsappAccounts />} />}
              />
              <Route path="/analytics" element={<ProtectedRoute element={<Analytics />} />} />
              <Route path="/dashboard" element={<ProtectedRoute element={<Dashboard />} />} />
              <Route path="/trial" element={<Trial />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
        </BrowserRouter>

    </React.Fragment>
  );
}

export default App;
